import * as React from 'react';
import { updateMktoActivity } from '../ta-services/ta-user-service';
import { TaAnswerData } from '../ta-shared';
import { TaResultDetails } from './ta-result-details/comp';
import { TaResultSummary } from './ta-result-summary/comp';

type TaResultPagePorps = {
	fullName: string;
	company: string;
	email: string;
	userAnswerssData: TaAnswerData[];
};

type TaResultPageState = {
	isScrollBtnVisible: boolean;
}

export class TaResultPage extends React.PureComponent<TaResultPagePorps, TaResultPageState> {

	state: TaResultPageState = {
		isScrollBtnVisible: false
	};

	componentDidMount () {
		updateMktoActivity('END');
		window.addEventListener('scroll', this.toggleScrollButton);
	}

	toggleScrollButton = () => {
		if (window.pageYOffset > 150) {
			if (!this.state.isScrollBtnVisible) {
				this.setState({isScrollBtnVisible: true});
			}
		} else {
			if (this.state.isScrollBtnVisible) {
				this.setState({isScrollBtnVisible: false});
			}
		}
	}

	scrollPageUp = () => {
		window.scrollTo({
			top: 0,
			left: 0,
			behavior: 'smooth'
		});
	}

	render () {
		return (
			<div className='ta-results-container'>
				<TaResultSummary
					userAnswerssData={this.props.userAnswerssData}
					fullName={this.props.fullName}
					company={this.props.company}
					email={this.props.email}
				/>

				<TaResultDetails
					userAnswerssData={this.props.userAnswerssData}
					fullName={this.props.fullName}
				/>
				{this.state.isScrollBtnVisible && <div onClick={this.scrollPageUp} className='ta-result-go-up-btn'><span>&uarr;</span></div>}
			</div>
		);
	}
}
